import React, { FC } from 'react';
import { Accordion } from '@components/atoms/Accordion';
import { Typography } from '@components/atoms/Typography';
import styles from './Faqs.module.css';

interface FaqsProps {
    items: {
        question: string;
        answer: string;
    }[];
}

export const Faqs: FC<FaqsProps> = ({ items }) => {
    return (
        <Accordion
            items={items.map((item, index) => {
                return {
                    id: `question-${index}`,
                    buttonContent: (isActive) => (
                        <div className="d-flex">
                            <Typography color="primary">
                                <i className={`${styles.icon} fa-sharp fa-solid ${isActive ? 'fa-minus' : 'fa-plus'}`} />
                            </Typography>
                            <div className="d-flex flex-column">
                                <Typography fontSize="24" fontWeight="900">
                                    {item.question}
                                </Typography>
                            </div>
                        </div>
                    ),
                    bodyContent: (
                        <Typography fontSize="16" color="muted">
                            {item.answer}
                        </Typography>
                    ),
                };
            })}
            customClasses={{
                accordionItem: styles['custom-accordion-item'],
                accordionButton: styles['custom-accordion-button'],
                accordionBody: styles['custom-accordion-body'],
            }}
        />
    );
};
